import { useEffect, useState } from "react";
import { loadSalesPreferences } from "../qv4/salesPreferences";
import { personalSettingsUserId, readPersonalSetting, writePersonalSetting } from '../../utils/personalSettings';

const EVENT = "uzdpart360:chat-notification-preferences";
const key = userId => `uzdpart360:chat-notifications:${userId}`;

// Per user, for customer and supplier chats separately: the popup
// (`customer`, `supplier`) and its sound (`customerSound`, `supplierSound`).
// Older choices carry over: the single mute for popups, and the one sound
// switch that used to sit with the sales pipeline settings.
export function loadChatNotificationPreferences(userId) {
  userId = personalSettingsUserId(userId);
  if (userId == null) return { customer: false, supplier: false, customerSound: false, supplierSound: false, staffPresence: false };
  try {
    let saved = null;
    try { saved = JSON.parse(readPersonalSetting(userId, key) || "null"); } catch {}
    const legacyPopups = localStorage.getItem("wati_notifications_enabled") !== "false";
    const legacySound = loadSalesPreferences(userId).soundEnabled;
    const pick = (value, fallback) => typeof value === "boolean" ? value : fallback;
    return {
      customer: pick(saved?.customer, legacyPopups),
      supplier: pick(saved?.supplier, legacyPopups),
      customerSound: pick(saved?.customerSound, legacySound),
      supplierSound: pick(saved?.supplierSound, legacySound),
      staffPresence: pick(saved?.staffPresence, true),
    };
  } catch { return { customer: true, supplier: true, customerSound: true, supplierSound: true, staffPresence: true }; }
}
export function saveChatNotificationPreferences(userId, value) {
  const requestedUserId = userId;
  userId = personalSettingsUserId(userId);
  if (userId == null) throw new Error("Sign in before saving personal settings.");
  const saved = writePersonalSetting(requestedUserId, key, JSON.stringify({
    customer: value.customer !== false, supplier: value.supplier !== false,
    customerSound: value.customerSound !== false, supplierSound: value.supplierSound !== false,
    staffPresence: value.staffPresence !== false,
  }));
  if (!saved) throw new Error('Your account changed. Reopen personal settings.');
  window.dispatchEvent(new Event(EVENT));
}
export function useChatNotificationPreferences(userId) {
  const [value, setValue] = useState(() => loadChatNotificationPreferences(userId));
  useEffect(() => {
    const refresh = () => setValue(loadChatNotificationPreferences(userId));
    refresh();
    window.addEventListener(EVENT, refresh);
    window.addEventListener("storage", refresh);
    return () => { window.removeEventListener(EVENT, refresh); window.removeEventListener("storage", refresh); };
  }, [userId]);
  return value;
}
